import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BRAND_LOGO_V2 from '../../images/Insights.gif';

import Button from '../../ui-components/Button/Button';
import 'ui-library-aol/dist/style.css';
import '../../styles/home.css';


const Home = () => {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    let user = window.localStorage.getItem('email');

    const isSmallScreen = window.innerWidth < 600;

    // fetch logged user email from the base app cookie
    function getCookie(name) {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
          const [key, value] = cookie.split("=");
          if (key === name) return decodeURIComponent(value);
        }
        return null;
      }
  
      const emailFromCookies = getCookie("email");
      // console.log('user email as fethced from base app cookies', emailFromCookies);
      // set to local storage
     if (emailFromCookies) {
      user = emailFromCookies;
      window.localStorage.setItem('email', user);
      }
      


      useEffect(() => {
        // Auto direct to the analytic dashboard if user is logged in
        if (user) {
          navigate("/analytic");
        } 
      }, [user, navigate]);

    return (
        <>
        <div className='home-container'>
            <div className='logo-container'>
                <img src={BRAND_LOGO_V2} alt='HIVE' className='home-image'></img>
            </div>
            <div className='home-btn-container'>
                {user ? 
                (                   
                  <Button variant="Primary" style={{ color: 'white' }} onClick={() => navigate("/analytic")}>Go to the Analytic dashboard</Button>
                ) :
                <Button variant="Primary" style={{ color: 'white', margin: '0.5rem 0' }} onClick={() => navigate("/auth/signin")}>Please Login to continue</Button>
                }
               
            </div> 
         
       </div>
       
   
        </>
       
      
        
        
  );
};

export default Home;
